var React = require('react');

function UpArrowOrange (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.0234 11.5C14.1567 11.5 14.2744 11.447 14.3758 11.3409C14.4649 11.2478 14.5058 11.1316 14.4993 10.9922C14.4935 10.8528 14.4454 10.7366 14.357 10.6435L8.56625 4.58928C8.41412 4.43021 8.22689 4.35 8.00454 4.35C7.7822 4.35 7.58911 4.43021 7.42398 4.58928L1.63328 10.6435C1.54486 10.7495 1.5 10.8692 1.5 11.0024C1.5 11.135 1.54486 11.2546 1.63328 11.3606C1.73535 11.4538 1.85237 11.5 1.98565 11.5C2.11892 11.5 2.23009 11.4538 2.31916 11.3606L7.99544 5.42542L13.6711 11.3606C13.7725 11.4538 13.8902 11.5 14.0234 11.5Z","fill":"#FF6200"}));
}

UpArrowOrange.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","className":"icon"};

module.exports = UpArrowOrange;

UpArrowOrange.default = UpArrowOrange;
